import React from "react";
import { TWalletData } from "../../types/PrincipalPositionTypes";
import { TooltipHost } from "@fluentui/react";
import { ImportantIcon } from "@fluentui/react-icons-mdl2";
// import ImportantIcon from "../../../../../icons/ImportantIcon";


const BASE_CLASS = "tableDistribution";

type TTableDistributionProps = {
    walletData: TWalletData
};

const TableDistribution: React.FC<TTableDistributionProps> = ({ walletData }) => {
  const localTheme = window.localStorage.getItem("theme") || "light";

  return (
      <div className={BASE_CLASS}>
        {walletData.walletProductInfo &&
            <table>
              <thead>
                <tr>
                  <th>HOLDINGS</th>
                  <th>CARTERA</th>
                    {walletData.walletProductInfo.map(product => 
                      <th>
                        <TooltipHost content={product.name}>

                          <h4>{product.isin}</h4>
                          <span>{product.name}</span>
                        </TooltipHost>
                      </th>
                    )
                  }
                </tr>
              </thead>
                <tbody>
                  {walletData.holdingInfo?.map((data, index) => (
                    <tr key={index}>
                      <td>
                        <TooltipHost content={data.holdingName}>
                          <div className={`${BASE_CLASS}__truncate`}>
                            <strong>{data.holdingName}</strong>
                          </div>
                        </TooltipHost>
                      </td>
                      <td>{data.holdingSumatory > 0.001
                        ? data.holdingSumatory + "%"
                        : "0.00%"
                      }</td>
                      {data.holdingFundWeight?.map((weight, idx) => (
                          <td className={`
                            ${weight !== 0
                              ? weight > 10
                                ? `${BASE_CLASS}__blue`
                                : `${BASE_CLASS}__green`
                              : ""}
                            ${index === walletData.holdingInfo.length - 1 ? `${BASE_CLASS}__transparent-bg` : ""}`}
                          key={idx}>
                            { weight > 0.001
                                ? weight + "%"
                                : weight == 0
                                  ? "-"
                                  : "0.00%"
                              
                            }
                            {/* { weight > 10 && data.holdingName !== "Others"
                              ? <ImportantIcon />
                              : <></>   
                            } */}
                          </td>   
                      ))}
                    </tr>
                    
                  ))}
                </tbody>
            </table>
        }
      </div>
    );

};

export default TableDistribution;